import api from '../api/index';

export default class UploadAdapter {
  constructor(loader, token) {
    this.loader = loader;
    this.token = token;
  }

  upload = () => {
    return this.loader.file.then((file) =>
      new Promise((resolve, reject) => {
        let imageFile = new FormData();
        imageFile.append('file', file);

        api
          .post('upload-file', imageFile, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer ' + this.token,
            },
          })
          .then((data) => {
            resolve({
              default: `${process.env.VUE_APP_IMAGES_ADDRESS}${data.data.data}`,
            });
          })
          .catch((error) => {
            return reject(`An error occurs: ${error}`);
          });
      }).catch((error) => {
        console.log(`An error occurs: ${error}`);
      })
    );
  };
}
